export class Form {
	constructor() {
		this.item = document.querySelectorAll('.js-file')
		this.itemArr = Array.prototype.slice.call(this.item)

		this.itemArr.forEach(item => {
			item.addEventListener('change', (event) => {
				this.validate_uploads(event);
			})
		});
	}

	validate_uploads(event) {
		let file = event.target.files[0],
		size = file.size,
		type = file.type,
		errors = ''
		console.log(size);
		console.log(file.type);
		//上限サイズは2MB
		if (size > 2000000) {
			errors += 'ファイルの上限サイズ2MBを超えています\n'
		}

		//拡張子は .jpg .gif .png . pdf のみ許可
		if (type != 'image/jpeg' && 
			type != 'image/gif' && 
			type != 'image/png' && 
			type != 'application/pdf' && 
			type != 'application/msword' && 
			type != 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' &&
			type != 'application/vnd.ms-excel' &&
			type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
			errors += '.jpeg、.gif、.png、.pdf、.doc、.docx、.xls、.xlsxのいずれかのファイルのみ添付が可能です\n'
		}

		if (errors) {
			//errorsが存在する場合は内容をalert
			alert(errors)
			//valueを空にしてリセットする
			event.currentTarget.value = ''
			}
		}

}
